import script from "./PostFigmaForMarketers.vue?vue&type=script&setup=true&lang=js"
export * from "./PostFigmaForMarketers.vue?vue&type=script&setup=true&lang=js"

import "./PostFigmaForMarketers.vue?vue&type=style&index=0&id=cd4f80ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4f80ce"]])

export default __exports__